export const selectPromises = (state) => state.promises.all || [];
export const selectCurrentPromise = (state) => state.promises?.current || null;
export const selectIsLoading = (state) => state.promises.isLoading;
export const selectLastPromise = (state) => state.promises.last || null;
export const selectPromiseCount = (state) => state.promises.count || 0;
export const selectPromiseCounts = (state) => state.promises.counts || null;
